import { useEffect } from 'preact/hooks';
import useUserDevice from './useUserDevice';
import Utils from '../../core/utils/utils';
import useLocalStorage from './useLocalStorage';

function useUserId() {
  const [userId, setUserId, clearId, isLoading] = useLocalStorage<string | null>("userId", null);
  const { device } = useUserDevice();
  useEffect(() => {
    if (isLoading) return; 
    if (!device) return;
    const handleUserId = async () => {
      console.log('storedUserId', userId);
      // clearId();
      if (!userId) {
        if (device === 'AppClip') {
          const url = new URL(window.location.href);
          const params = new URLSearchParams(url.search);
          const id = params.get('userId');
          if (id) {
            console.log('No ID exists in AppClip, using ID from query param:', id);
            setUserId(id);
            return;
          }
        } else {
          const newUserId = Utils.UUID();
          console.log('No ID exists, setting new ID:', newUserId);
          setUserId(newUserId);
          updateParams(newUserId);
        }
      } else {
        console.log('ID exists, get stored ID:', userId);
        setUserId(userId);
        updateParams(userId);
      }
    };

    handleUserId();
  }, [isLoading, device]);

  const updateParams = (id: string) => {
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    params.set('userId', id);
    const newUrl = `${url.origin}${url.pathname}?${params.toString()}${
      url.hash
    }`;
    window.history.replaceState(null, '', newUrl);
  };

  return userId;
}

export default useUserId;
